import styled, { css } from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi900 } from "../../styles/font.constants";

type ButtonVariant = "primary" | "secondary";

type ButtonStyleProps = {
	$variant?: ButtonVariant;
};

const getButtonVariant = (variant: ButtonVariant) => {
	if (variant === "secondary") {
		return css`
			background-color: ${colours.greyDark};
			color: ${colours.black};

			&:hover {
				background-color: ${colours.greyMedium};
			}

			&:disabled {
				background-color: ${colours.greyDarker};
				cursor: not-allowed;
			}
		`;
	}

	return css`
		color: ${colours.white};
		background-color: ${colours.red};
		&:hover {
			background-color: ${colours.redDark};
		}
		&:disabled {
			background-color: ${colours.greyDarker};
			cursor: not-allowed;
		}
	`;
};

export default styled.button<ButtonStyleProps>`
	${satoshi900}
	border: none;
	font-size: 1rem;
	padding: 0.85rem 1rem;
	border-radius: 50px;
	cursor: pointer;
	transition: background-color 0.2s ease;
	${({ $variant = "primary" }) => getButtonVariant($variant)}
`;
